module.exports = __webpack_public_path__ + "static/media/daxueIcon.1008ba28.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/daxueIcon.png
// module id = 651
// module chunks = 0 1